// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3VvY0","signatureButtonsRight":"ModalSign_signatureButtonsRight__323Gz"};